import Cookies from "js-cookie";
import jwtDecode from "jwt-decode";

const ID_TOKEN_KEY = "__unagii_v2_access_token__";
const ID_KEEP_LOGGED_IN_KEY = "__unagii_v2_keep_logged_in__";
const ID_REFRESH_TOKEN_KEY = "__unagii_v2_refresh_token__";
const TOKEN_EXPIRES_IN = 14; //14 days

export const getToken = () => {
  return Cookies.get(ID_TOKEN_KEY);
};

export const saveToken = (token, keepLoggedIn, opts) => {
  keepLoggedIn = setKeepLoggedIn(keepLoggedIn);
  return Cookies.set(ID_TOKEN_KEY, token, {
    expires: keepLoggedIn ? TOKEN_EXPIRES_IN : undefined,
    ...(opts || {})
  });
};

const setKeepLoggedIn = keepLoggedIn => {
  if (keepLoggedIn === undefined) {
    keepLoggedIn = localStorage.getItem(ID_KEEP_LOGGED_IN_KEY) && true;
  } else {
    if (keepLoggedIn === false) {
      localStorage.removeItem(ID_KEEP_LOGGED_IN_KEY);
    } else {
      localStorage.setItem(ID_KEEP_LOGGED_IN_KEY, 1);
    }
  }
  return keepLoggedIn;
};

export const destroyTokens = () => {
  Cookies.remove(ID_TOKEN_KEY);
  Cookies.remove(ID_REFRESH_TOKEN_KEY);
  localStorage.removeItem(ID_KEEP_LOGGED_IN_KEY);
};

export const decodeToken = token => {
  try {
    return jwtDecode(token);
  } catch (error) {
    return null;
  }
};

export const getRefreshToken = () => {
  return Cookies.get(ID_REFRESH_TOKEN_KEY);
};

export const saveRefreshToken = (token, opts = {}) => {
  const keepLoggedIn = localStorage.getItem(ID_KEEP_LOGGED_IN_KEY) && true;
  if (Cookies.get(ID_REFRESH_TOKEN_KEY)) return;
  const tokenDecoded = jwtDecode(token);
  return Cookies.set(ID_REFRESH_TOKEN_KEY, token, {
    expires: keepLoggedIn
      ? (tokenDecoded.exp * 1000 - Date.now()) / 86400000
      : undefined,
    ...opts
  });
};

export const destroyRefreshToken = () => {
  return Cookies.remove(ID_REFRESH_TOKEN_KEY);
};

export default {
  getToken,
  saveToken,
  destroyTokens,
  getRefreshToken,
  saveRefreshToken,
  destroyRefreshToken
};
